import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class MedicalEmergencyCardStore {
    flightStatusMenu: boolean = false;
    medicalDetailModal: boolean = false;
    medicalCardExpand: boolean = false;
    medicalCardExpandHover: boolean = false;
    phsicianFullName: string = "";

    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setFlightStatusMenu = () => {
        this.flightStatusMenu = !this.flightStatusMenu;
    }
    get getFlightStatusMenu() {
        return this.flightStatusMenu;
    }
    resetFlightStatusMenu = () => {
        this.flightStatusMenu = false;
    }

    setPassengerDetailModal = (isOpen: boolean) => {
        this.medicalDetailModal = isOpen;
    }
    get getPassengerDetailModal() {
        return this.medicalDetailModal;
    }

    setMedicalCardExpand = (isHover: boolean) => {
        this.medicalCardExpand = isHover
    }
    toggleMedicalCardExpand = () => {
        this.medicalCardExpand = !this.medicalCardExpand;
    }
    get getMedicalCardExpand() {
        return this.medicalCardExpand;
    }

    toggleMedicalCardExpandHover = (isHoverActive: boolean) => {
        this.medicalCardExpandHover = isHoverActive;
    }
    get getMedicalCardExpandHover() {
        return this.medicalCardExpandHover;
    }

    setPhysicianFName = (name: string) => {
        this.phsicianFullName = name;
    }
    get getPhysicianFName() {
        return this.phsicianFullName;
    }
}